export default {
  title: 'Generar QR Codes',

  name: 'Nombre del lote',
  amount: 'Cantidad de QR Codes'
}
